export const DevExtremeComponentName = {
    'DataGrid': 'dxDataGrid',
    'SelectBox': 'dxSelectBox',
    'DropDownBox': 'dxDropDownBox',
    'DateBox': 'dxDateBox'
}